export const NOTEBOOK_TAB_KEY = 'NOTEBOOK';
export const FLASHCARDS_TAB_KEY = 'FLASHCARDS';
export const ACCOUNT_TAB_KEY = "ACCOUNT";